/**
 * Placement of the popover panel relative to the element the directive is applied to.
 *
 * The first token is the side the panel sits on; the second is how it aligns along that side.
 * `center-left` / `center-right` sit beside the anchor, vertically centered.
 */
export type PopoverPlacement =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'center-right'
  | 'bottom-right'
  | 'bottom-center'
  | 'bottom-left'
  | 'center-left';

export const DEFAULT_POPOVER_PLACEMENT: PopoverPlacement = 'top-center';
export const DEFAULT_POPOVER_CLOSE_LABEL = 'Close';

/** Distance between the anchor and the panel, and between the panel and the viewport edge. */
export const POPOVER_ANCHOR_GAP = 8;
export const POPOVER_VIEWPORT_MARGIN = 8;

export { Popover } from './popover';
export { PopoverPanel } from './popover-panel';
